import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { Point } from "pixi.js";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Modules } from "@lib/titan2/dist/game/Constants";
export class FeatureReelSymbolProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    setDefaultValues() {
        this.size = new Point(170, 170);
        this.fishContainer = new AbstractViewProperties(new Point(75, 69));
        this.bubble = new SpriteProperties("Blank_v2", Modules.GAME, new Point(72, 85), new Point(0.75, 0.75), new Point(0.5, 0.5));
        this.fish = {
            blue: new SpriteProperties("prop_watch", "Game", new Point(70, 85), new Point(0.45, 0.45), new Point(0.5, 0.5)),
            green: new SpriteProperties("prop_snuffbox", "Game", new Point(70, 85), new Point(0.45, 0.45), new Point(0.5, 0.5)),
            red: new SpriteProperties("prop_hairclip", "Game", new Point(72, 85), new Point(0.45, 0.45), new Point(0.5, 0.5)),
            purple: new SpriteProperties("prop_tuna", "Game", new Point(70, 85), new Point(0.45, 0.45), new Point(0.5, 0.5)),
            gold: new SpineProperties("SiameseCat", "Game", new Point(72, 200), new Point(0.35, 0.35))
        };
        this.catMask = new SpriteProperties("YarnMask", "Game", new Point(78, 75), new Point(0.85492, 1), new Point(0.5, 0.5));
    }
    ;
    equals(other) {
        return true;
    }
}
//# sourceMappingURL=FeatureReelSymbolProperties.js.map